import React, { useEffect, useRef } from "react";
import "./CategoriesSection.css";

const WORDS = [
  { text: "OTC", from: "right" },
  { text: "MEDICINES", from: "left" },
  { text: "NATURALS", from: "right" },
  { text: "MOBILITY", from: "left" },
  { text: "PERSONAL CARE", from: "right" },
];

export default function CategoriesSection() {
  const sectionRef = useRef(null);
  const itemRefs = useRef([]);

  useEffect(() => {
    const handleScroll = () => {
      if (!sectionRef.current) return;

      const rect = sectionRef.current.getBoundingClientRect();
      const vh = window.innerHeight;

      itemRefs.current.forEach((el, i) => {
        if (!el) return;

        const trigger = rect.top + i * 120;
        const distance = vh / 2 - trigger;

        const progress = Math.max(0, Math.min(1, distance / 200));
        const offset = (1 - progress) * 300;
        const dir = WORDS[i].from === "left" ? -1 : 1;

        if (i === 0) {
          // OTC → slide horizontally only
          el.style.transform = `translateX(${dir * offset}px)`;
        } else {
          // Other words → center axis
          el.style.transform = `
            translate(-50%, ${i * 100}px)
            translateX(${dir * offset}px)
          `;
        }

        el.style.opacity = 0.6 + progress * 0.4;
      });
    };

    window.addEventListener("scroll", handleScroll);
    handleScroll();
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <section ref={sectionRef} className="categories-section">
      <div className="categories-wrap">

        {/* FIRST ROW: LEFT TEXT + RIGHT OTC */}
        <div className="categories-top-row">
          <p className="categories-sub">
            Broad range of treatments<br />
            for comprehensive <br />
            healthcare.
          </p>

          <span
            ref={(el) => (itemRefs.current[0] = el)}
            className="cat-otc"
          >
            OTC
          </span>
        </div>

        {/* CENTER STACK */}
        <div className="categories-center">
          {WORDS.slice(1).map((item, i) => (
            <div
              key={item.text}
              ref={(el) => (itemRefs.current[i + 1] = el)}
              className="cat-line"
            >
              {item.text}
            </div>
          ))}
        </div>

      </div>
    </section>
  );
}
